import React from "react";
import { ButtonSelector } from "app/interaction/ButtonSelector/ButtonSelector";

import "./style.scss";

export interface Props {
    headerLabel?: string;
    /** Array of strings to be used  as label for each table row. */
    rowLabels: string[];
    /** Array of objects that represent each column. */
    children: { label: string; items: (string | null)[] }[];
}

const arrayToObject = (inArray: any[]) =>
    inArray.reduce((obj, value, index) => {
        // @ts-ignore
        obj[index.toString()] = value;
        return obj;
    }, {});

/**
 * Renders a table which columns are selectable on a mobile device.
 */
export const SelectableColumnTable = ({ headerLabel, rowLabels, children }: Props) => {
    const [activeColumn, setActiveColumn] = React.useState("0");

    return (
        <div className="selectableColumnTable">
            <ButtonSelector
                value={activeColumn}
                onChange={setActiveColumn}
                items={arrayToObject(children.map(c => c.label))}
            />
            <table className={`active-${activeColumn}`}>
                <thead>
                    <tr>
                        <th> {headerLabel ? headerLabel : ""} </th>
                        {children.map(({ label }, index) => (
                            <th key={index}>{label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {children[0].items.map((ignore, rowIndex) => {
                        return (
                            <tr key={rowIndex}>
                                <td>{rowLabels[rowIndex]}</td>
                                {children.map(({ items }, columnIndex) => (
                                    <td key={columnIndex} className={`c${columnIndex}`}>
                                        {items[rowIndex] || "-"}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
